import { defineComponent as _defineComponent } from 'vue'
import type { Area, Category, Keyword } from '@ilteducation/content-ref-data-types';
import { computed, ref } from 'vue';
import type { VideoV1 } from '@ilteducation/content-registry-types';
import { getAllRefData } from '@/data-provider/refDataProvider';
import ArrayInput from '@/components/base/ArrayInput.vue';

type Props = {
  id?: string;
  title: string;
  item?: Area;
  videos: VideoV1[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null,
    videos: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: Area;
  videos: VideoV1[];
}



const notEmptyRule = ref([(val: any) => (val || '').length > 0 || 'This field is required']);

const availableSubjects = ref<Category[]>([]);
const refDataKeywords = ref<Keyword[]>([]);

const keywords = computed<Keyword[]>(() => {
  const keywordsInArea = props.videos.flatMap((vid) => vid.keywords);
  return refDataKeywords.value.filter((kw) => !!kw.imageId && keywordsInArea.includes(kw?.id));
});

const isManabuaCategory = (category: Category) => category.subscriptionTypes?.some((sub) => sub.includes('immigrant'));

getAllRefData('categories').then((categories: Category[]) => {
  availableSubjects.value = categories.filter((c) => isManabuaCategory(c));
});

getAllRefData('keywords').then((kws) => {
  refDataKeywords.value = kws;
});

const DefaultItem = ref({
  active: true,
  order: props.item?.order || 9000,
});

const category = computed(() =>
  availableSubjects.value.find((c: Category) => props.item && c.id === props.item.categoryId),
);
const areaGuideUrl = computed(() => {
  if (!category.value || !props.item) {
    return undefined;
  }
  const environment = process.env.VUE_APP_ENVIRONMENT;
  const market = category.value.realms![0];
  return `https://${environment === 'production' ? 'app' : 'app-dev'}.${
    market === 'se' ? 'begreppa' : 'manabua'
  }.${market}/videos/${category.value.slug}/${props.item.slug}`;
});

return { __sfc: true,props, notEmptyRule, availableSubjects, refDataKeywords, keywords, isManabuaCategory, DefaultItem, category, areaGuideUrl, ArrayInput }
}

})